import LegalPage from "../components/LegalPage";
import { CONTACT_EMAIL } from "../data/content";

export default function DisclaimerPage() {
  return (
    <LegalPage
      testid="disclaimer-page"
      title="Disclaimer"
      updated="July 2026"
      seoTitle="Disclaimer | The Jamoon"
      seoDescription="Important information about the wilderness nature of The Jamoon — remoteness, wildlife sightings, walking and the assumption of risk — to read before you book or travel."
      intro="The Jamoon is a genuine wilderness experience, not a conventional hotel. Please read the following before you book or travel, so your expectations match the forest you are about to walk into."
      sections={[
        {
          heading: "A true wilderness, off the grid",
          body: "The lodge sits deep in the forest beside the Ramganga, with no mains electricity, no Wi-Fi and limited or no mobile signal. Power is solar and lamplight. Guests should be prepared for a rustic, nature-first stay rather than modern urban comforts.",
        },
        {
          heading: "Wildlife is wild",
          body: "The forest is unscripted. Sightings of tigers, leopards, elephants, birds or any other wildlife can never be promised or guaranteed. Photographs on this website are representative of the region and of past experiences by our guests and visiting photographers — they are not a guarantee of what you will see.",
        },
        {
          heading: "Walking and fitness",
          body: "Reaching The Jamoon involves a walk of roughly 3.5 kilometres through the forest, and most experiences — walks, hides and safaris — take place on uneven natural terrain. Guests take part at their own discretion and should be in reasonable physical health.",
        },
        {
          heading: "Safety and assumption of risk",
          body: "Wilderness travel carries inherent risks — terrain, weather, water, remoteness and wild animals among them. To the extent permitted by law, The Jamoon and its staff accept no liability for injury, loss or damage arising from circumstances beyond our reasonable control. Please follow your naturalist's guidance at all times.",
        },
        {
          heading: "Content and imagery",
          body: "Information, rates and imagery on this site are provided in good faith and may change without notice. Certain photographs are the work of, and credited to, their respective photographers and are used with permission; they remain the property of their owners.",
        },
        {
          heading: "External links",
          body: "Where we link to third-party websites for your convenience, we are not responsible for their content, accuracy or privacy practices.",
        },
        {
          heading: "Bookings",
          body: "All bookings are subject to the inclusions, rates and cancellation policy shown on our Packages page, which form part of these terms.",
        },
        {
          heading: "Contact",
          body: "If anything here is unclear, please write to us at " + CONTACT_EMAIL + " before you book — we would rather talk it through.",
        },
      ]}
    />
  );
}
